import type { NumberComparisonOperator } from "@redotech/redo-flows-core-common/comparison-operators";
import { Schema } from "../type-system/schema";

export const numberComparisonToLabel: Record<NumberComparisonOperator, string> =
  {
    ["lessThan"]: "less than",
    ["greaterThan"]: "greater than",
    ["equalTo"]: "equal to",
    ["notEqualTo"]: "not equal to",
  };

export interface NumberComparisonExpression {
  type: "number_comparison";
  field: keyof Schema["fields"];
  operator: NumberComparisonOperator;
  comparisonValue: number;
}
